'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleQuickQuoteSubmit = exports.clearQuotes = exports.fetchFullQuote = exports.fetchQuotes = exports.fetchQuotesWithGuidHackedOutFromAThemeObject = undefined;
var _regenerator = require('babel-runtime/regenerator');
var _regenerator2 = _interopRequireDefault(_regenerator);
var _arrayToIso = require('@marmalade/date/lib/array-to-iso');
var _arrayToIso2 = _interopRequireDefault(_arrayToIso);
var _formInfo = require('@marmalade/form/lib/selectors/form-info');
var _axios = require('axios');
var _axios2 = _interopRequireDefault(_axios);
var _guid = require('../guid');
var _guid2 = _interopRequireDefault(_guid);
var _constants = require('../new-business/constants');
var _constants2 = require('./constants');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }
        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }
      return step("next");
    });
  };
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
var defaultAction = _constants2.actionTypes.QUOTE;
var fetchQuotesWithGuidHackedOutFromAThemeObject = exports.fetchQuotesWithGuidHackedOutFromAThemeObject = function fetchQuotesWithGuidHackedOutFromAThemeObject(params, theme) {
  var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'POST';
  return function (dispatch, getState) {
    return dispatch(fetchQuotes(Object.assign({}, params, {
      guid: (0, _guid2.default)(getState(), theme)
    }), method));
  };
};
var fetchQuotes = exports.fetchQuotes = function fetchQuotes(params) {
  var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'GET';
  var url = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _constants2.url;
  var actionType = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : defaultAction;
  return function (dispatch) {
    var req = _defineProperty({
      method: method,
      url: url
    }, method === 'POST' ? 'data' : 'params', params);
    dispatch({
      type: actionType,
      payload: (0, _axios2.default)(req),
      meta: {
        params: params,
        marmalytics: 'quote'
      }
    });
    // Get the hash here as we always have the age/postcode when quoting
    if (url === _constants2.url) {
      _axios2.default.get(_constants2.dlAttributionUrl, {
        params: {
          age: params.age,
          postcode: params.postcode
        }
      }).then(function (res) {
        if (res.data.status === 'SUCCESS') {
          dispatch({
            type: _constants2.actionTypes.SET_DL_ATTRIBUTION,
            hash: res.data.data
          });
        }
      });
    }
  };
};
var fetchFullQuote = exports.fetchFullQuote = function fetchFullQuote(theme) {
  var suppressEmail = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return function () {
    var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(dispatch, getState) {
      var state, stage2, stage3, stage4, userGuid, req;
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              state = getState();
              stage2 = (0, _formInfo.getValues)(state, _constants.stages[1].formId);
              stage3 = (0, _formInfo.getValues)(state, _constants.stages[2].formId);
              stage4 = (0, _formInfo.getValues)(state, _constants.stages[3].formId);
              userGuid = (0, _guid2.default)(state, theme);
              req = {
                method: 'POST',
                url: _constants2.fullQuoteUrl,
                data: Object.assign({}, stage2, stage3, stage4, {
                  dateOfBirth: (0, _arrayToIso2.default)(stage2.dateOfBirth),
                  licenceStartDate: (0, _arrayToIso2.default)(stage2.licenceStartDate),
                  vehiclePurchaseDate: (0, _arrayToIso2.default)(stage3.vehiclePurchaseDate),
                  coverStartDate: (0, _arrayToIso2.default)(stage4.coverStartDate),
                  suppressEmail: suppressEmail,
                  guid: userGuid
                })
              };
              _context.next = 8;
              return dispatch({
                type: _constants2.actionTypes.FULL_QUOTE,
                payload: (0, _axios2.default)(req),
                meta: {
                  params: req.data,
                  marmalytics: 'quote'
                }
              });
            case 8:
              _context.next = 10;
              return _axios2.default.get(_constants2.dlAttributionUrl, {
                params: {
                  age: req.data.age,
                  postcode: req.data.postcode
                }
              }).then(function (res) {
                if (res.data.status === 'SUCCESS') {
                  dispatch({
                    type: _constants2.actionTypes.SET_DL_ATTRIBUTION,
                    hash: res.data.data
                  });
                }
              });
            case 10:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, undefined);
    }));
    return function (_x6, _x7) {
      return _ref.apply(this, arguments);
    };
  }();
};
var clearQuotes = exports.clearQuotes = function clearQuotes() {
  return {
    type: _constants2.actionTypes.CLEAR_QUOTES
  };
};
var handleQuickQuoteSubmit = exports.handleQuickQuoteSubmit = function handleQuickQuoteSubmit(guid) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'NEW';
  var fdiQuote = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return function (dispatch) {
    return function () {
      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(formState) {
        var d, _formState$values, abiCode, age, postcode, regNo, value;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (formState.validAndPristine) {
                  d = new Date();
                  _formState$values = formState.values, abiCode = _formState$values.abiCode, age = _formState$values.age, postcode = _formState$values.postcode, regNo = _formState$values.regNo, value = _formState$values.value;
                  dispatch(fetchQuotes({
                    age: age,
                    coverStartDate: d.toISOString().substring(0, 10),
                    postcode: postcode,
                    type: type,
                    guid: guid,
                    abiCode: abiCode,
                    regNo: regNo,
                    value: value
                  }));
                  if (fdiQuote) {
                    dispatch(fetchQuotes({
                      abiCode: abiCode,
                      age: age,
                      guid: guid,
                      licenceHeld: '5',
                      licenceType: 'P',
                      postcode: postcode,
                      regNo: regNo,
                      value: value
                    }, 'POST', _constants2.fdiUrl, _constants2.actionTypes.FDI_QUOTE));
                  }
                }
              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, undefined);
      }));
      return function (_x10) {
        return _ref2.apply(this, arguments);
      };
    }();
  };
};